'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var preact = require('preact');
var preact__default = _interopDefault(preact);
var classNames = _interopDefault(require('classnames'));

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var preactPortal = createCommonjsModule(function (module, exports) {
(function (global, factory) {
  module.exports = factory(preact__default);
}(commonjsGlobal, (function (preact) {
var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Portal = function (_Component) {
	inherits(Portal, _Component);

	function Portal() {
		classCallCheck(this, Portal);
		return possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
		for (var i in props) {
			if (props[i] !== this.props[i]) {
				return setTimeout(this.renderLayer);
			}
		}
	};

	Portal.prototype.componentDidMount = function componentDidMount() {
		this.isMounted = true;
		this.renderLayer = this.renderLayer.bind(this);
		this.renderLayer();
	};

	Portal.prototype.componentWillUnmount = function componentWillUnmount() {
		this.renderLayer(false);
		this.isMounted = false;
		if (this.remote) this.remote.parentNode.removeChild(this.remote);
	};

	Portal.prototype.findNode = function findNode(node) {
		return typeof node === 'string' ? document.querySelector(node) : node;
	};

	Portal.prototype.renderLayer = function renderLayer() {
		var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

		if (!this.isMounted) return;

		if (this.props.into !== this.intoPointer) {
			this.intoPointer = this.props.into;
			if (this.into && this.remote) {
				this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
			}
			this.into = this.findNode(this.props.into);
		}

		this.remote = preact.render(preact.h(
			PortalProxy,
			{ context: this.context },
			show && this.props.children || null
		), this.into, this.remote);
	};

	Portal.prototype.render = function render() {
		return null;
	};

	return Portal;
}(preact.Component);

var PortalProxy = function (_Component2) {
	inherits(PortalProxy, _Component2);

	function PortalProxy() {
		classCallCheck(this, PortalProxy);
		return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	PortalProxy.prototype.getChildContext = function getChildContext() {
		return this.props.context;
	};

	PortalProxy.prototype.render = function render(_ref) {
		var children = _ref.children;

		return children && children[0] || null;
	};

	return PortalProxy;
}(preact.Component);

return Portal;

})));

});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".cte-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.cte-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.cte-button:active{color:#1253b5;border:1px solid #1253b5}.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button[disabled]:active,.cte-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.cte-button-primary.cte-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.cte-button-primary.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button-primary.cte-button[disabled]:active,.cte-button-primary.cte-button[disabled]:hover{background:#1c6cdc;color:#fff}.cte-button-primary.cte-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.cte-button-primary.cte-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.cte-button-danger{background:#ff5f57;color:#fff}.cte-button-disabled{opacity:.45;cursor:not-allowed}";
styleInject(css);

class Button extends preact.Component {
  render() {
    const {
      children,
      type,
      prefix,
      disabled,
      onClick
    } = this.props;
    return preact.h("button", {
      disabled: disabled,
      className: classNames(prefix, {
        [`${prefix}-danger`]: type === 'danger',
        [`${prefix}-primary`]: type === 'primary',
        [`${prefix}-disabled`]: disabled
      }),
      onClick: onClick
    }, children);
  }

}

Button.defaultProps = {
  type: '',
  prefix: 'cte-button',
  disabled: false
};

var css$1 = ".cte-modal{position:fixed;background-color:rgba(0,0,0,.5);z-index:1002}.cte-modal,.cte-modal .mask{top:0;left:0;right:0;bottom:0}.cte-modal .mask{position:absolute}.cte-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.cte-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.cte-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.cte-modal-header-close:hover{background:rgba(0,0,0,.07)}.cte-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M557.248 512l279.083 279.061-45.27 45.27L512 557.227 232.939 836.33l-45.27-45.291L466.773 512 187.67 232.939l45.27-45.27L512 466.773 791.061 187.67l45.27 45.27z' fill-opacity='.6'/%3E%3C/svg%3E\") no-repeat 50%}.cte-modal-body{padding:0 24px}.cte-modal-content{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.cte-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}";
styleInject(css$1);

const defaultModalWidth = {
  small: 400,
  middle: 600,
  large: 800,
  super: 960
};

class Modal extends preact.Component {
  constructor(...args) {
    super(...args);

    this.onKeyDown = e => {
      const {
        onOk,
        canEnter
      } = this.props;

      if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
        onOk();
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    };
  }

  render() {
    const {
      children,
      className,
      title,
      contentClassName,
      okText = "确定",
      cancelText = "取消",
      onOk,
      disabled,
      onCancel,
      showFooter = true,
      wrapper,
      prefix,
      type
    } = this.props;
    return preact.h(preactPortal, {
      into: wrapper || "body"
    }, preact.h("div", {
      className: `${prefix} ${className || ""}`
    }, preact.h("div", {
      className: "mask"
    }), preact.h("div", {
      className: `${prefix}-content ${contentClassName || ""}`,
      style: {
        width: defaultModalWidth[type]
      },
      onKeyDown: this.onKeyDown
    }, preact.h("div", {
      className: `${prefix}-header`
    }, preact.h("div", {
      className: `${prefix}-header-title`
    }, title), preact.h("div", {
      className: `${prefix}-header-close`,
      onClick: onCancel
    }, preact.h("button", {
      className: `${prefix}-header-close-icon`
    }))), preact.h("div", {
      className: `${prefix}-body`
    }, children), showFooter && preact.h("div", {
      className: `${prefix}-footer`
    }, preact.h(Button, {
      onClick: onCancel
    }, cancelText), preact.h(Button, {
      type: "primary",
      className: "ok",
      onClick: onOk,
      disabled: disabled
    }, okText)))));
  }

}

Modal.defaultProps = {
  prefix: 'cte-modal',
  type: 'middle',
  canEnter: false
};

var css$2 = ".ct-menu-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-menu-item svg{margin:4px 0 0 4px}.ct-menu-item.edit{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 7a.5.5 0 1 1 0 1H8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-5a.5.5 0 1 1 1 0v-2 7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h7-2zm6.854-.854a.5.5 0 0 1 0 .708l-6.364 6.364a.5.5 0 1 1-.708-.708l6.364-6.364a.5.5 0 0 1 .708 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.visitLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.674 16h1.128a6.001 6.001 0 1 0 0-6H6.674a7 7 0 1 1 0 6zm7.472-1.232l1.268-1.268H6.621a.5.5 0 1 1 0-1h8.793l-1.268-1.268a.5.5 0 0 1 .708-.707l2.1 2.101a.5.5 0 0 1 .021.727l-2.121 2.122a.5.5 0 1 1-.708-.707z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.ct-menu-item.cancelLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l1.842-1.841a2.011 2.011 0 1 1 2.844 2.844l-1.99 1.991.71.711-2.133 2.134-1.067-1.067.356.356.15-.15a2.011 2.011 0 0 0 0-2.844l-.712-.711.711-.711-.71-.712zM7.354 7.354a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707L7.354 8.06a.5.5 0 0 1 0-.707zm9 9a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707l-1.414-1.414a.5.5 0 0 1 0-.707zM17 14.5a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zm-11-3a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zM11.5 6a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5zm3 11a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
styleInject(css$2);

class MenItem extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasTooltip: false
    };
  }

  render() {
    const {
      tip,
      onClick,
      type
    } = this.props;
    return preact.h("div", {
      className: `ct-menu-item ${type}`,
      onMouseEnter: () => this.setState({
        hasTooltip: true
      }),
      onMouseLeave: () => this.setState({
        hasTooltip: false
      }),
      onClick: onClick
    }, this.state.hasTooltip && preact.h("span", {
      className: "ct-toolbar-tooltip"
    }, tip));
  }

}

var css$3 = ".ct-toolbox .checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-toolbox .checkbox input{display:none}.ct-toolbox .checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-toolbox .checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-toolbox .checkbox input:checked+.checkbox-bg:after{content:\" \";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}";
styleInject(css$3);

// @jsx h
class CheckBox extends preact.Component {
  render() {
    const {
      checked,
      onClick,
      children
    } = this.props;
    return preact.h("div", {
      className: "checkbox",
      onClick: onClick
    }, preact.h("input", {
      type: "checkbox",
      checked: checked
    }), preact.h("span", {
      className: "checkbox-bg"
    }), preact.h("span", {
      className: "checkbox-label"
    }, children));
  }

}

exports.Modal = Modal;
exports.IconItem = MenItem;
exports.CheckBox = CheckBox;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/components/index.js